import React from "react";
import { skillGroups } from "../data/portfolioData";
import "./Skills.css";

const Skills = () => (
  <section id="skills" className="portfolio-section skills-section" data-scene-section="skills">
    <div className="section-wrap" data-animate="true">
      <header className="destination-heading destination-heading--split">
        <div>
          <div className="destination-label"><span>05</span><span>Technical constellation</span></div>
          <h2 className="section-title">A connected engineering toolkit.</h2>
        </div>
        <p className="section-lede">Languages, systems, and platforms organized by the work they enable—not by logo count.</p>
      </header>
      <dl className="skills-list">
        {skillGroups.map((group, index) => (
          <div key={group.title}>
            <span className="skill-coordinate" aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
            <dt>{group.title}</dt>
            <dd>
              {group.skills.map((skill, index) => (
                <React.Fragment key={skill}>
                  <span>{skill}</span>
                  {index < group.skills.length - 1 && <i aria-hidden="true">·</i>}
                </React.Fragment>
              ))}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  </section>
);

export default Skills;
